import { UnauthedHubSpotUserAvatar } from 'avatar-components/UnauthedHubSpotUserAvatar';
import { makeUserIdForSelect } from './UsersAndTeamsSearchUtils';
import { formatUserFullNameForDisplay } from '../../utils/UserUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeUserSelectOption = (user, userIdsForSelectedTeamIds, disabledUsers, allowedUserIds) => {
  const {
    id,
    email
  } = user;
  const isMemberOfSelectedTeam = userIdsForSelectedTeamIds.includes(id);
  let isUserDisabled = false;
  if (disabledUsers) {
    isUserDisabled = disabledUsers.includes(id);
  } else if (allowedUserIds) {
    isUserDisabled = !allowedUserIds.includes(id);
  }
  return {
    value: makeUserIdForSelect(id),
    text: formatUserFullNameForDisplay(user),
    isMemberOfSelectedTeam,
    // custom prop used for rendering the disabled tooltip
    isUserDisabled,
    disabled: isMemberOfSelectedTeam || isUserDisabled,
    avatar: /*#__PURE__*/_jsx(UnauthedHubSpotUserAvatar, {
      size: "xs",
      hubSpotUserEmail: email
    })
  };
};